module.exports = __webpack_public_path__ + "img/tw.48ef657a.svg";